import { render, staticRenderFns } from "./livelihood.vue?vue&type=template&id=f72b7242&scoped=true&"
import script from "./livelihood.vue?vue&type=script&lang=js&"
export * from "./livelihood.vue?vue&type=script&lang=js&"
import style0 from "./livelihood.vue?vue&type=style&index=0&id=f72b7242&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72b7242",
  null
  
)

export default component.exports